import React from 'react';
import { useTranslation } from 'react-i18next';

const Settings = () => {
	const { t } = useTranslation();

	return (
		<div id="Settings1" className="page">
			<div className="wrapper">
				<div className="pageTitle">
					<a className="backButton" href="#"></a>
					<h1>{t('Settings')}</h1>
				</div>

			</div>
		</div>
	);
};

export default React.memo(Settings);
